import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import RegionDataService from "../../services/RegionService";

const Region = (props) => {
  const cacheTitle = props.location.state?.cacheTitle ;
  console.log(`Last Info - props ${props.location.state?.cacheTitle}`);

  const initialRegionState = {
    id: null,
    name: "",
  };
  const [currentRegion, setCurrentRegion] = useState(initialRegionState);
  const [message, setMessage] = useState("");

  const getRegion = id => {
    RegionDataService.get(id)
      .then(response => {
        setCurrentRegion(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    getRegion(props.match.params.id);
  }, [props.match.params.id]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentRegion({ ...currentRegion, [name]: value });
  };

  const updateRegion = () => {
    RegionDataService.update(currentRegion.id, currentRegion)
      .then(response => {
        console.log(response.data);
        setMessage("區域內容更新！");
        props.history.push({
          pathname: "/Regions",
          state: {
            cacheTitle: cacheTitle
          }
        });
      })
      .catch(e => {
        console.log(e);
      });
  };

  return (
    <div>
      {currentRegion ? (
        <div className="edit-form">
          <h4>區域</h4>
          <form>
            <div className="form-group">
              <label htmlFor="name">名稱</label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                value={currentRegion.name}
                onChange={handleInputChange}
              />
            </div>
          </form>

          <button
            type="submit"
            className="btn btn-success"
            onClick={updateRegion}
          >
            更新
          </button>
          <p>{message}</p>
        </div>
      ) : (
        <div>
          <br />
          {/* <p>Please click on a Region...</p> */}
        </div>
      )}
    </div>
  );
};

export default withRouter(Region);
